import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Test } from '../_model/test';
import { AnalyticsEvent } from '../_model/analytics-event';
import { ChangePassword } from '../_model/changepassword';
import { environment } from '../../environments/environment';

@Injectable()
export class PDFService {

    constructor(private http: HttpClient) {
    }

    createPDF(tests: Test[]): Observable<any> {
        const url: string = "https://pdfer.etrality.com/pdf"
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post(url, tests, {headers: headers, responseType: 'blob', observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    private handleErrorObservable(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(error.message || error);
    }

}
